(() => {
  // ════════════════════════════════════════════════════════════════════
  // SHARED
  // ════════════════════════════════════════════════════════════════════
  const ROOT_SEL = ".ea-sticky-cart";

  const detectLang = (() => {
    let c = null;
    return () => {
      if (c) return c;
      const l = (document.documentElement.lang || "").toLowerCase();
      return c = /^pl/.test(l) ? "pl" : /^de/.test(l) ? "de" : /^es/.test(l) ? "es" : /^nl/.test(l) ? "nl" : /^ro/.test(l) ? "ro" : "en";
    };
  })();

  const parseNum = (s) => {
    if (!s) return NaN;
    if (s.includes(",")) return parseFloat(s.replace(/\./g, "").replace(",", "."));
    if (/\.\d{1,2}$/.test(s)) return parseFloat(s);
    return parseFloat(s.replace(/\./g, ""));
  };

  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, c =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])
  );

  // ════════════════════════════════════════════════════════════════════
  // MODULE 1 — discount split bar
  // ════════════════════════════════════════════════════════════════════
  const DISC_INSERT_SEL = ".eascRecoRow.eascRecoRowBox";
  const DISC_SRC_SEL    = ".easc-miniCartSubtotalDivInnerDiscounts .easc-discCodeName";
  const DISC_ID         = "ea-discount-split-outside";
  const DISC_CLS        = "ea-discount-split";

  const TIERS = [
    { qty: 2, pct: 5 },
    { qty: 3, pct: 7 },
    { qty: 4, pct: 10 },
  ];

  const SVG_TAG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_13105_464)">
    <mask id="mask0_13105_464" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
    <path d="M0 9.53674e-07H16V16H0V9.53674e-07Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_13105_464)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0215 2.51038C13.2802 2.51038 13.4902 2.72038 13.4902 2.97913C13.4902 3.23788 13.2802 3.44788 13.0215 3.44788C12.7627 3.44788 12.5527 3.23788 12.5527 2.97913C12.5527 2.72038 12.7627 2.51038 13.0215 2.51038Z" fill="black"/>
    <path d="M15.237 7.7921C15.4256 7.60357 15.5312 7.34826 15.5312 7.08188V1.47291C15.5312 1.20654 15.4256 0.951227 15.237 0.762946C15.0487 0.574415 14.7935 0.468727 14.5271 0.468727H8.91809C8.65175 0.468727 8.39644 0.574415 8.20787 0.762946L0.763031 8.20782C0.370656 8.6002 0.370656 9.23582 0.763031 9.62795L6.37203 15.2369C6.76416 15.6294 7.39978 15.6294 7.79219 15.2369C9.54919 13.4799 14.0446 8.98454 15.237 7.7921Z" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.00025 4.15547C8.55453 4.15547 9.00441 4.6056 9.00441 5.15963C9.00441 5.71394 8.55453 6.16382 8.00025 6.16382C7.44597 6.16382 6.99609 5.71394 6.99609 5.15963C6.99609 4.6056 7.44597 4.15547 8.00025 4.15547Z" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.00025 9.83602C8.55453 9.83602 9.00441 10.2859 9.00441 10.8402C9.00441 11.3942 8.55453 11.8444 8.00025 11.8444C7.44597 11.8444 6.99609 11.3942 6.99609 10.8402C6.99609 10.2859 7.44597 9.83602 8.00025 9.83602Z" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.98828 8H11.0132" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </g>
    <defs>
    <clipPath id="clip0_13105_464">
    <rect width="16" height="16" fill="white"/>
    </clipPath>
    </defs>
    </svg>`;
  const SVG_CHECK = `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7" fill="none">
    <path d="M7.58398 0.583374L2.77148 5.58337L0.583984 3.31065" stroke="#15803D" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
  const SVG_ARROW = `<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.33333 7.66672H9.862L7.764 5.56939C7.70141 5.5068 7.66625 5.42191 7.66625 5.33339C7.66625 5.24487 7.70141 5.15998 7.764 5.09739C7.82659 5.0348 7.91148 4.99963 8 4.99963C8.08852 4.99963 8.17341 5.0348 8.236 5.09739L10.9027 7.76406C10.9337 7.79502 10.9583 7.8318 10.9751 7.8723C10.9919 7.9128 11.0006 7.95621 11.0006 8.00006C11.0006 8.0439 10.9919 8.08731 10.9751 8.12781C10.9583 8.16831 10.9337 8.20509 10.9027 8.23606L8.236 10.9027C8.17341 10.9653 8.08852 11.0005 8 11.0005C7.91148 11.0005 7.82659 10.9653 7.764 10.9027C7.70141 10.8401 7.66625 10.7552 7.66625 10.6667C7.66625 10.5782 7.70141 10.4933 7.764 10.4307L9.862 8.33339H5.33333C5.24493 8.33339 5.16014 8.29827 5.09763 8.23576C5.03512 8.17325 5 8.08846 5 8.00006C5 7.91165 5.03512 7.82686 5.09763 7.76435C5.16014 7.70184 5.24493 7.66672 5.33333 7.66672Z" fill="currentColor"/></svg>`;

  const norm     = (s) => String(s || "").replace(/\u00A0/g, " ").replace(/\s+/g, " ").trim();
  const deParenS = (s) => String(s || "").replace(/\(\s*s\s*\)/gi, "s");

  const findPercents  = (t) => { const out = [], re = /(\d+(?:[.,]\d+)?)\s*%/g; let m; while ((m = re.exec(t))) out.push(parseFloat(m[1].replace(",", "."))); return out; };
  const findCount     = (t) => { const s = deParenS(norm(t)).toLowerCase(); const m = s.match(/(\d+)\s+(?:więcej\s+)?(?:przedmiot(?:ów|y)?|produkt(?:ów|y)?|artyku(?:ł|ły|łów)?|artikel|item(?:s)?|article(?:s)?|art[íi]culo(?:s)?|producto(?:s)?|produs(?:e)?)\b/i); return m ? parseInt(m[1], 10) : 1; };
  const isCongrats    = (t) => /(gratulacje|congrat|glückwunsch|enhorabuena|gefelic|felicit|felicidades)/i.test(t);
  const findTierByPct = (p) => TIERS.find(t => Math.abs(t.pct - p) < 0.01) || null;

  const UNIT = {
    pl: () => "szt.", de: () => "Artikel", en: (n) => n === 1 ? "item" : "items",
    es: (n) => n === 1 ? "artículo" : "artículos", nl: (n) => n === 1 ? "artikel" : "artikelen",
    ro: (n) => n === 1 ? "produs" : "produse",
  };

  const DISC_TPL = {
    pl: { no_discount: () => "Dodaj produkty i odbierz rabat",              have: p => `Masz ${p}% rabatu`,         add_more: () => "Dodaj produkty i oszczędzaj więcej"      },
    de: { no_discount: () => "Produkte hinzufügen und Rabatt erhalten",     have: p => `Du hast ${p}% Rabatt`,      add_more: () => "Mehr Produkte hinzufügen und sparen"     },
    en: { no_discount: () => "Add products and get a discount",             have: p => `You have ${p}% off`,        add_more: () => "Add products and save more"              },
    es: { no_discount: () => "Añade productos y obtén descuento",           have: p => `Tienes ${p}% de descuento`, add_more: () => "Añade más productos y ahorra"            },
    nl: { no_discount: () => "Voeg producten toe en ontvang korting",       have: p => `Je hebt ${p}% korting`,     add_more: () => "Voeg meer producten toe en bespaar"      },
    ro: { no_discount: () => "Adaugă produse și primești reducere",         have: p => `Ai ${p}% reducere`,         add_more: () => "Adaugă mai multe produse și economisești" },
  };

  const activeLabel   = (tier, lang) => `${esc(tier.qty + " " + UNIT[lang](tier.qty))} ${SVG_ARROW} ${esc(tier.pct + "%")}`;
  const inactiveLabel = (tier, qty, lang) => { const d = tier.qty - qty; return `${esc("+" + d + " " + UNIT[lang](d))} ${SVG_ARROW} ${esc(tier.pct + "%")}`; };

  const parseDiscState = (raw) => {
    const t = norm(raw);
    if (!t) return null;
    const lang  = detectLang();
    const percs = findPercents(t);
    const n     = findCount(t);
    if (isCongrats(t) && percs.length >= 1) {
      const tier = findTierByPct(percs[0]) || TIERS[TIERS.length - 1];
      return { lang, activeTier: tier, currentQty: tier.qty };
    }
    if (percs.length >= 2) {
      const activeTier = findTierByPct(percs[0]), nextTier = findTierByPct(percs[1]);
      if (activeTier) return { lang, activeTier, currentQty: nextTier ? nextTier.qty - n : activeTier.qty };
    }
    if (percs.length === 1) {
      const nextTier = findTierByPct(percs[0]);
      if (nextTier) return { lang, activeTier: null, currentQty: nextTier.qty - n };
      return { lang, activeTier: TIERS[TIERS.length - 1], currentQty: TIERS[TIERS.length - 1].qty };
    }
    return { lang, activeTier: null, currentQty: 0 };
  };

  const buildDisc = ({ lang, activeTier, currentQty }) => {
    const higher  = TIERS.filter(t => !activeTier || t.qty > activeTier.qty);
    const pills   = higher.map(t => `<span class="${DISC_CLS}__tier ${DISC_CLS}__tier--inactive">${inactiveLabel(t, currentQty, lang)}</span>`).join("");
    const wrap    = document.createElement("div");
    wrap.id       = DISC_ID;
    if (!activeTier) {
      wrap.className = `${DISC_CLS} ${DISC_CLS}--no-discount`;
      wrap.innerHTML = `
        <div class="${DISC_CLS}__header">
          <span class="${DISC_CLS}__tag-icon" aria-hidden="true">${SVG_TAG}</span>
          <span class="${DISC_CLS}__title">${esc(DISC_TPL[lang].no_discount())}</span>
        </div>
        ${higher.length ? `<div class="${DISC_CLS}__tiers">${pills}</div>` : ""}`;
    } else {
      wrap.className = `${DISC_CLS} ${DISC_CLS}--has-discount${higher.length === 0 ? ` ${DISC_CLS}--max` : ""}`;
      wrap.innerHTML = `
        <div class="${DISC_CLS}__inner">
          <div class="${DISC_CLS}__left">
            <div class="${DISC_CLS}__header">
              <span class="${DISC_CLS}__tag-icon" aria-hidden="true">${SVG_TAG}</span>
              <span class="${DISC_CLS}__title">${esc(DISC_TPL[lang].have(activeTier.pct))}</span>
            </div>
            <div class="${DISC_CLS}__tier ${DISC_CLS}__tier--active">
              <span class="${DISC_CLS}__check" aria-hidden="true">${SVG_CHECK}</span>
              <span>${activeLabel(activeTier, lang)}</span>
            </div>
          </div>
          ${higher.length ? `
          <div class="${DISC_CLS}__right">
            <p class="${DISC_CLS}__subtitle">${esc(DISC_TPL[lang].add_more())}</p>
            <div class="${DISC_CLS}__tiers">${pills}</div>
          </div>` : ""}
        </div>`;
    }
    return wrap;
  };

  let lastDiscKey = null;
  const upsertDisc = (root) => {
    const beforeEl = root.querySelector(DISC_INSERT_SEL);
    if (!beforeEl) return;
    const src = root.querySelector(DISC_SRC_SEL);
    if (!src) return;
    const state = parseDiscState(src.getAttribute("data-ea-raw") || src.textContent || "");
    if (!state) return;
    const key  = `${state.activeTier?.pct ?? "none"}|${state.currentQty}`;
    const out  = root.querySelector("#" + DISC_ID);
    const same = out && out.nextSibling === beforeEl;
    if (key === lastDiscKey && same) return;
    lastDiscKey = key;
    const el = buildDisc(state);
    if (!out) beforeEl.parentNode.insertBefore(el, beforeEl);
    else { out.replaceWith(el); if (!same) beforeEl.parentNode.insertBefore(el, beforeEl); }
  };

  // ════════════════════════════════════════════════════════════════════
  // MODULE 2 — cart summary rows
  // ════════════════════════════════════════════════════════════════════
  const SUM_CHECKOUT_SEL = ".easc-miniCartSubtotalDiv";
  const SUM_REWARDS_SEL  = ".easc-rewardsBar";
  const SUM_ID           = "ea-cart-summary-custom";

  const SUM_TPL = {
    pl: { items: n => `PRODUKTY (${n})`,  shipping: "KOSZT DOSTAWY", free: "Darmowa"   },
    de: { items: n => `PRODUKTE (${n})`,  shipping: "VERSANDKOSTEN", free: "Kostenlos"  },
    en: { items: n => `PRODUCTS (${n})`,  shipping: "SHIPPING",      free: "Free"       },
    es: { items: n => `PRODUCTOS (${n})`, shipping: "ENVÍO",         free: "Gratis"     },
    nl: { items: n => `PRODUCTEN (${n})`, shipping: "VERZENDING",    free: "Gratis"     },
    ro: { items: n => `PRODUSE (${n})`,   shipping: "LIVRARE",       free: "Gratuit"    },
  };

  const parseEAPrice = (raw) => {
    if (!raw) return null;
    const text = raw.replace(/^[\s\u2212-]+/, "").trim();
    const m = text.match(/^([^\d\s]{1,6})\s?([\d,.]+)$/) || text.match(/^([\d,.]+)\s?([^\d\s]{1,6})$/);
    if (!m) return null;
    const isSuf = /^\d/.test(m[1]);
    const num   = isSuf ? m[1] : m[2];
    const cur   = isSuf ? m[2] : m[1];
    const sep   = num.includes(",") ? "," : ".";
    return { cents: Math.round(parseNum(num) * 100), pre: isSuf ? "" : cur + " ", suf: isSuf ? " " + cur : "", sep };
  };

  const fmtCents = (cents, f) => f.pre + (Math.abs(cents) / 100).toFixed(2).replace(".", f.sep) + f.suf;

  const readCartDOM = (root) => {
    const sub = root.querySelector(".easc-miniCartSubtotalDivInner:not(.easc-miniCartSubtotalDivInnerDiscounts)");
    if (!sub) return null;
    const fmt = parseEAPrice(sub.querySelector(".ml-3")?.textContent?.trim());
    if (!fmt) return null;
    const save      = parseEAPrice(sub.querySelector(".easc-subtotalDiscText")?.textContent?.trim());
    const discCents = fmt.cents;
    const saveCents = save?.cents ?? 0;
    const count     = parseInt(root.querySelector(".easc-cartCountDiv p, .easc-miniCartCount p")?.textContent?.trim(), 10) || 0;
    const prog      = root.querySelector(`${SUM_REWARDS_SEL} .Polaris-ProgressBar__Progress`);
    return { discCents, origCents: discCents + saveCents, count, freeShip: prog ? Number(prog.value) >= 100 : false, fmt };
  };

  const buildSum = ({ discCents, origCents, count, freeShip, fmt }) => {
    const t    = SUM_TPL[detectLang()] || SUM_TPL.en;
    const f    = c => fmtCents(c, fmt);
    const wrap = document.createElement("div");
    wrap.id    = SUM_ID;
    wrap.className = "ea-cart-summary";
    if (!freeShip) return wrap;
    wrap.innerHTML = `
      <div class="ea-cart-summary__rows">
        <div class="ea-cart-summary__row">
          <span class="ea-cart-summary__label">${t.items(count)}</span>
          <div class="ea-cart-summary__prices">
            ${origCents !== discCents ? `<span class="ea-cart-summary__original">${f(origCents)}</span>` : ""}
            <span class="ea-cart-summary__price">${f(discCents)}</span>
          </div>
        </div>
        <div class="ea-cart-summary__row">
          <span class="ea-cart-summary__label">${t.shipping}</span>
          <span class="ea-cart-summary__shipping ea-cart-summary__shipping--free">${t.free}</span>
        </div>
      </div>`;
    return wrap;
  };

  const patchSubtotal = (root) => {
    root.querySelectorAll(".easc-subtotalDiscText").forEach(el => {
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (/-/.test(node.nodeValue)) { node.nodeValue = node.nodeValue.replace(/^[\s\u2212-]+/, ""); break; }
      }
    });
  };

  let lastSumKey = null;
  const upsertSum = (root) => {
    const checkoutDiv = root.querySelector(SUM_CHECKOUT_SEL);
    if (!checkoutDiv) return;
    const data = readCartDOM(root);
    if (!data) return;
    const existing = root.querySelector("#" + SUM_ID);
    const key = `${data.discCents}|${data.origCents}|${data.count}|${data.freeShip}`;
    if (key === lastSumKey && existing) return;
    lastSumKey = key;
    const newEl = buildSum(data);
    if (existing) existing.replaceWith(newEl);
    else checkoutDiv.parentNode.insertBefore(newEl, checkoutDiv);
    patchSubtotal(root);
  };

  // ════════════════════════════════════════════════════════════════════
  // MODULE 3 — product price badges
  // ════════════════════════════════════════════════════════════════════
  const augmentRows = (root) => {
    root.querySelectorAll(".eascProdBox .easc-productRow").forEach(row => {
      const box   = row.querySelector(".easc-lineItemHeight");
      if (!box) return;
      const orig  = parseNum(box.querySelector(".lineItemDiscText")?.textContent?.match(/([\d,.]+)/)?.[1] || "") || 0;
      const final = parseNum(box.querySelector("div.text-right")?.textContent?.match(/([\d,.]+)/)?.[1] || "") || 0;
      const pct   = orig > final && orig > 0 ? Math.round((1 - final / orig) * 100) : 0;
      const key   = `${orig}|${final}`;
      if (row.dataset.epState === key) return;
      row.dataset.epState = key;
      box.querySelector(".ea-item-disc-badge")?.remove();
      if (!pct) return;
      box.insertAdjacentHTML("beforeend", `<span class="ea-item-disc-badge-container"><span class="ea-item-disc-badge">-${pct}%</span></span>`);
    });
  };

  // ════════════════════════════════════════════════════════════════════
  // MODULE 4 — rewards bar: bold the price when not free yet
  // ════════════════════════════════════════════════════════════════════
  const patchRewardsBar = (root) => {
    const prog = root.querySelector(`${SUM_REWARDS_SEL} .Polaris-ProgressBar__Progress`);
    if (!prog || Number(prog.value) >= 100) return;
    const p = root.querySelector(`${SUM_REWARDS_SEL} p`);
    if (!p || p.querySelector("strong.rb-price")) return;

    const PRICE_RE = /((?:zł|PLN|€|EUR|\$|USD|£|GBP|CHF|SEK|NOK|DKK|CZK|HUF|RON|lei|kr)\s*[\d]+[.,][\d.,]+|[\d]+[.,][\d.,]+\s*(?:zł|PLN|€|EUR|\$|USD|£|GBP|CHF|SEK|NOK|DKK|CZK|HUF|RON|lei|kr))/i;

    const walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const m = node.nodeValue.match(PRICE_RE);
      if (!m) continue;
      const before = node.nodeValue.slice(0, m.index);
      const after  = node.nodeValue.slice(m.index + m[0].length);
      const strong = document.createElement("strong");
      strong.className = "rb-price";
      strong.textContent = m[0];
      const parent = node.parentNode;
      if (before) parent.insertBefore(document.createTextNode(before), node);
      parent.insertBefore(strong, node);
      if (after) parent.insertBefore(document.createTextNode(after), node);
      parent.removeChild(node);
      break;
    }
  };

  // ════════════════════════════════════════════════════════════════════
  // SHARED OBSERVER + BOOT
  // ════════════════════════════════════════════════════════════════════
  let isUpdating = false, debounceTimer = null, rootObserver = null;

  const runAll = (root) => {
    upsertDisc(root);
    upsertSum(root);
    augmentRows(root);
    patchRewardsBar(root);
  };

  const schedule = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const root = document.querySelector(ROOT_SEL);
      if (!root) return;
      isUpdating = true;
      runAll(root);
      setTimeout(() => { isUpdating = false; }, 0);
    }, 300);
  };

  const attachObserver = (root) => {
    rootObserver?.disconnect();
    rootObserver = new MutationObserver(mutations => {
      if (isUpdating) return;
      if (mutations.some(m => [...m.removedNodes].some(n => n?.id === SUM_ID)))  lastSumKey  = null;
      if (mutations.some(m => [...m.removedNodes].some(n => n?.id === DISC_ID))) lastDiscKey = null;
      schedule();
    });
    rootObserver.observe(root, { subtree: true, childList: true, characterData: true });
  };

  const boot = () => {
    const root = document.querySelector(ROOT_SEL);
    if (root) { attachObserver(root); schedule(); }

    new MutationObserver(() => {
      const r = document.querySelector(ROOT_SEL);
      if (r && !rootObserver) { attachObserver(r); schedule(); }
      if (!r && rootObserver) { rootObserver.disconnect(); rootObserver = null; lastSumKey = null; lastDiscKey = null; }
    }).observe(document.body, { childList: true });
  };

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot, { once: true })
    : boot();
})();
